import React, {useCallback} from 'react';

import {keyDisplayName} from '../../../../../util/runs';
import {
  type MetricSearchOption,
  MetricSearchSelect,
} from '../../../../MetricSearch/MetricSearchSelect';
import {
  SLIDER_KEY_RESULT_LIMIT,
  SLIDER_KEY_TYPES,
} from './mediaKeySelectShared';

// `_step` is always valid but is not a logged metric, so metric search never
// returns it.
const STEP_OPTION: MetricSearchOption = {value: '_step', label: 'Step'};
const RESERVED_OPTIONS = [STEP_OPTION];

/**
 * Slider key picker backed by metric search, for the NGW path.
 *
 * Mirrors `SliderKey`, but sources numeric keys from the metric search API
 * rather than `useMediaKeys`, whose key info NGW leaves empty.
 */
export const SliderKeyMetricSearch = ({
  currentMediaSliderKey,
  onSliderKeyChange,
}: {
  currentMediaSliderKey: string;
  onSliderKeyChange: (value: string) => void;
}) => {
  const labelForValue = useCallback(
    (name: string) => keyDisplayName({section: 'summary', name}),
    []
  );

  return (
    <MetricSearchSelect
      // `_step` stays pinned whatever the user types, as it did before this
      // picker moved onto the shared component.
      alwaysShowReservedOptions
      ariaLabel="Select Slider Key"
      className="flex flex-col gap-4"
      labelForValue={labelForValue}
      onChange={onSliderKeyChange}
      reservedOptions={RESERVED_OPTIONS}
      resultLimit={SLIDER_KEY_RESULT_LIMIT}
      types={SLIDER_KEY_TYPES}
      value={currentMediaSliderKey}
    />
  );
};
